// モバイルメニュー（15-mobile）。MENU で開き、CLOSE × ／ Esc で閉じる。開いている間は body のスクロールを止める。
(function () {
  var btn = document.querySelector('.menu-btn');
  var menu = document.getElementById('site-menu');
  if (!btn || !menu) return;

  function set(open) {
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('lock-menu', open); // cart.js と body.style を取り合わない
    if (open) {
      var c = menu.querySelector('.close');
      if (c) c.focus();
    } else {
      btn.focus();
    }
  }

  btn.addEventListener('click', function () { set(menu.hidden); });
  menu.addEventListener('click', function (e) {
    if (e.target.closest('.close')) set(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.hidden) set(false);
  });
})();
